import Client from 'config/axios';

export const getSuggestedPostDetail = async (id: string, token: string) => {
  const { data } = await Client.get(`suggested_post/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return {
    data
  };
};
